import { useMemo } from 'react';

import { useBadge } from '@/_components';

export const useHighlightedText = (value: string) => {
  const { cls } = useBadge({
    type: 'primary',
    size: 'sm',
    className: 'py-0.5 min-w-4 my-0 px-2 text-xs bg-accent text-white normal-case dark:text-primary',
  });
  const nValue = useMemo(() => value.replace(/{([^}]*)}/g, `<span class="${cls}">$1</span>`), [cls, value]);

  return nValue;
};
